export const GRID_PAGES = [50, 75, 100]
export const ROWS_PER_PAGE = 50
export const DEFAULT_PAGE = 0